export { default } from './WindForecastData';
